import { Accordion } from "flowbite-react"

const NodeJsFAQ: React.FC = () => {
  return (
    <>
      <Accordion>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
          What is Node.js?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
            Node.js is a JavaScript runtime environment that enables developers to build scalable, event-driven applications. {`It's`} perfect for backend development and real-time applications.

             
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            {" "}
            Why should I choose Node.js for my project?

          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
            Node.js offers fast, scalable, and cost-effective solutions for building modern web and mobile applications. Its ability to handle thousands of requests simultaneously makes it ideal for building real-time, scalable apps. Learn more about how Moweb can help you with Node.js web application development.

            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
            {" "}
            What tools are used in Node.js development?

          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
            Our Node.js developers use tools like NPM (Node Package Manager), Express.js, and MongoDB for database management. These tools allow for the efficient development of full-stack applications.

            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
          Can I migrate my existing application to Node.js?

          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
            Yes! Our Node.js migration services ensure that your application can transition to Node.js without downtime or data loss. We offer node js consulting services to guide you through the migration process.
            
            </div>
          </Accordion.Content>
        </Accordion.Panel>
        <Accordion.Panel>
          <Accordion.Title as="h3" className="accordion-title">
          What is the cost of Node.js development?
          </Accordion.Title>
          <Accordion.Content className="accordion-border">
            <div className="fs-md mb-0 text-secondary">
            The cost of development depends on the scope and complexity of the project. Contact us for a detailed quote tailored to your{` project’s `}specific requirements.

            </div>
          </Accordion.Content>
        </Accordion.Panel>
      </Accordion>
    </>
  )
}

export default NodeJsFAQ
